import { MainLayout } from "../components/layout/MainLayout";
import { Header } from "../components/layout/Header";
import {
  Phone,
  Mail,
  MessageCircle,
  Clock,
  HelpCircle,
  FileText,
  Video,
  BookOpen,
} from "lucide-react";

export default function HelpSupport() {
  const supportPhone = "+919876543210";
  const supportEmail = "support@juhnuhnee.com";

  const handlePhoneClick = () => {
    window.location.href = `tel:${supportPhone}`;
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${supportEmail}`;
  };

  return (
    <MainLayout>
      <Header
        title="Help & Support"
        subtitle="We're here to help you manage your restaurant better"
      />

      <div className="p-6 space-y-6">
        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Phone Support Card */}
          <button
            onClick={handlePhoneClick}
            className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all duration-200 hover:border-primary/50 text-left group"
          >
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                <Phone className="w-6 h-6 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-1">
                  Call Support
                </h3>
                <p className="text-sm text-muted-foreground mb-3">
                  Speak directly with our support team
                </p>
                <div className="flex items-center gap-2">
                  <span className="text-xl font-semibold text-primary group-hover:underline">
                    {supportPhone}
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-3 text-xs text-muted-foreground">
                  <Clock className="w-4 h-4" />
                  <span>Available 24/7</span>
                </div>
              </div>
            </div>
          </button>

          {/* Email Support Card */}
          <button
            onClick={handleEmailClick}
            className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all duration-200 hover:border-secondary/50 text-left group"
          >
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-secondary/10 flex items-center justify-center group-hover:bg-secondary/20 transition-colors">
                <Mail className="w-6 h-6 text-secondary" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-1">
                  Email Support
                </h3>
                <p className="text-sm text-muted-foreground mb-3">
                  Send us a detailed message
                </p>
                <div className="flex items-center gap-2">
                  <span className="text-lg font-semibold text-secondary group-hover:underline">
                    {supportEmail}
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-3 text-xs text-muted-foreground">
                  <Clock className="w-4 h-4" />
                  <span>Response within 24 hours</span>
                </div>
              </div>
            </div>
          </button>
        </div>

      

        {/* Support Information */}
        <div className="bg-card border border-border rounded-lg p-6">
          <h2 className="text-lg font-semibold text-foreground mb-4">
            What to expect when you contact us
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-sm font-semibold text-primary">1</span>
              </div>
              <div>
                <h3 className="font-medium text-foreground mb-1">
                  Immediate Response
                </h3>
                <p className="text-sm text-muted-foreground">
                  Our team will acknowledge your request right away
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-secondary/10 flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-sm font-semibold text-secondary">2</span>
              </div>
              <div>
                <h3 className="font-medium text-foreground mb-1">
                  Expert Guidance
                </h3>
                <p className="text-sm text-muted-foreground">
                  Get help from restaurant management specialists
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-success/10 flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-sm font-semibold text-success">3</span>
              </div>
              <div>
                <h3 className="font-medium text-foreground mb-1">
                  Follow-up Support
                </h3>
                <p className="text-sm text-muted-foreground">
                  We'll ensure your issue is completely resolved
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* System Information */}
        <div className="bg-muted/30 border border-border rounded-lg p-6">
          <h3 className="font-semibold text-foreground mb-3">
            System Information
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div>
              <span className="text-muted-foreground">Version:</span>
              <span className="ml-2 font-medium text-foreground">2.5.0</span>
            </div>
            <div>
              <span className="text-muted-foreground">Last Updated:</span>
              <span className="ml-2 font-medium text-foreground">
                January 2, 2026
              </span>
            </div>
            <div>
              <span className="text-muted-foreground">Outlet ID:</span>
              <span className="ml-2 font-medium text-foreground">
                JHN-BPL-001
              </span>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}